import { render } from "./TargetingTypeFilterBody.vue?vue&type=template&id=6647289e"
import script from "./TargetingTypeFilterBody.vue?vue&type=script&lang=js"
export * from "./TargetingTypeFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__